import { Button, Card, Modal } from '..';
import { useTranslation } from 'react-i18next';
import AndroidIcon from 'assets/svg/android.svg?react';
import AppleIcon from 'assets/svg/apple.svg?react';
import React, { memo } from 'react';
import styles from './OTPModal.module.scss';

export type Props = {
  onClose: () => void;
  isOpen?: boolean;
  dataTest?: string;
};

export default memo(function OTPModal({
  onClose,
  isOpen = false,
  dataTest = 'otp-modal',
}: Props) {
  const { t } = useTranslation('otp_modal');

  const androidPoints: Object = t('android_points', {
    returnObjects: true,
  });

  const iosPoints: Object = t('ios_points', {
    returnObjects: true,
  });

  return (
    <Modal
      dataTest={dataTest}
      className={styles.modal}
      classNameContainer={styles.modalContainer}
      classNameContent={styles.content}
      isOpen={isOpen}
    >
      <div className={styles.title} data-testid={`${dataTest}-title`}>
        {t('title')}
      </div>

      <div
        className={styles.description}
        data-testid={`${dataTest}-description`}
      >
        {t('description')}
      </div>
      <div data-testid={`${dataTest}-cards-container`}>
        <Card className={styles.card} dataTest={`${dataTest}-android-card`}>
          <div
            className={styles.iconHeader}
            data-testid={`${dataTest}-android-header`}
          >
            <AndroidIcon
              className={styles.icon}
              data-testid={`${dataTest}-android-icon`}
            />
            <span
              className={styles.appName}
              data-testid={`${dataTest}-android-app-name`}
            >
              {t('android_app')}
            </span>
          </div>
          <div
            className={styles.points}
            data-testid={`${dataTest}-android-points`}
          >
            {Object.values(androidPoints).map((point, index) => (
              <div
                key={index}
                data-testid={`${dataTest}-android-point-${index}`}
              >
                <span
                  className={styles.pointNumber}
                  data-testid={`${dataTest}-android-point-number-${index}`}
                >
                  {index + 1}
                </span>
                <span data-testid={`${dataTest}-android-point-text-${index}`}>
                  {point}
                </span>
              </div>
            ))}
          </div>
        </Card>
        <Card className={styles.card} dataTest={`${dataTest}-ios-card`}>
          <div
            className={styles.iconHeader}
            data-testid={`${dataTest}-ios-header`}
          >
            <AppleIcon
              className={styles.icon}
              data-testid={`${dataTest}-ios-icon`}
            />
            <span
              className={styles.appName}
              data-testid={`${dataTest}-ios-app-name`}
            >
              {t('ios_app')}
            </span>
          </div>
          <div className={styles.points} data-testid={`${dataTest}-ios-points`}>
            {Object.values(iosPoints).map((point, index) => (
              <div key={index} data-testid={`${dataTest}-ios-point-${index}`}>
                <span
                  className={styles.pointNumber}
                  data-testid={`${dataTest}-ios-point-number-${index}`}
                >
                  {index + 1}
                </span>
                <span data-testid={`${dataTest}-ios-point-text-${index}`}>
                  {point}
                </span>
              </div>
            ))}
          </div>
        </Card>
      </div>
      <Button
        className={styles.cto}
        onClick={onClose}
        dataTest={`${dataTest}-close-button`}
      >
        {t('cto')}
      </Button>
    </Modal>
  );
});
